module.exports = {
  host: '',
  port: 465,
  secure: true,
  auth: {
    user: '',
    pass: ''
  }
};